import { useCallback, useState } from 'react';
import {
  CheckoutTransactionParams,
  useCheckoutPrewarm,
} from '@/features/subscription/contexts/CheckoutPrewarm';

type EnsureTransactionParams = CheckoutTransactionParams;

export function useCreateTransaction(defaultPaywallType: string) {
  const { ensureTransaction: ensureSharedTransaction } = useCheckoutPrewarm();
  const [transactionId, setTransactionId] = useState<string | undefined>(
    undefined
  );

  const clearTransaction = useCallback(() => {
    setTransactionId(undefined);
  }, []);

  const ensureTransaction = useCallback(
    async ({
      priceId,
      discountId,
      quantity,
      toolType,
      paywallType,
    }: EnsureTransactionParams) => {
      const id = await ensureSharedTransaction({
        priceId,
        discountId,
        quantity,
        toolType,
        paywallType: paywallType || defaultPaywallType || 'in_app',
      });

      setTransactionId(id);
      return id;
    },
    [defaultPaywallType, ensureSharedTransaction]
  );

  return {
    transactionId,
    ensureTransaction,
    clearTransaction,
  };
}
